export const UNREGISTERED_POPUP_STORAGE_KEY = 'unregistered_popup_ready';
export const UNREGISTERED_POPUP_DELAY_MS = 3000;
export const UNREGISTERED_POPUP_OPEN_LOCK_KEY = 'unregistered_popup_open';
export const UNREGISTERED_POPUP_PRESENTED_KEY = 'unregistered_popup_presented';
export const UNREGISTERED_POPUP_PRESENTED_EVENT = 'unregistered_popup_presented_event';
